<ng-container [formGroup]="parentFormGroup">
  <fieldset formGroupName="metadataList">
    <legend>
      <div>
        <span i18n>Metadata</span>
        <div>
          @if (listInheritableType !== 'empty') {
            <eas-editor-booking-item-inheritable-type-badge [inheritableType]="listInheritableType">
            </eas-editor-booking-item-inheritable-type-badge>
          }
        </div>
      </div>
    </legend>
    <p i18n>
      Metadata is used to assign any custom information you wish to utilise as part of an integration service.
    </p>
    <table>
      @for (itemMetadata of itemMetadataList; track itemMetadata; let itemMetadataIndex = $index) {
        <tr>
          <td>
            <span [style.text-decoration]="itemMetadata.inheritableType === 'empty' ? 'line-through' : null">{{ itemMetadata.name }}</span>
          </td>
          <td [formGroup]="getMetadataFormGroup(itemMetadataIndex)">
            <div class="form-container">
              <mat-form-field appearance="outline">
                <mat-label i18n>Value</mat-label>
                <input matInput id="metadata-value" type="text" formControlName="value">
              </mat-form-field>
            </div>
          </td>
          <td>
            @if (isDeletable(itemMetadataIndex)) {
              <button
                mat-icon-button
                aria-label="Delete metadata value"
                i18n-aria-label
                (click)="onDelete(itemMetadataIndex)">
                <mat-icon inline>delete</mat-icon>
              </button>
            }
          </td>
        </tr>
      }

      @for (newItemMetadataControl of newItemMetadataListFormArray.controls; track newItemMetadataControl; let newItemMetadataIndex = $index) {
        <tr>
          <td [formGroup]="getNewMetadataFormGroup(newItemMetadataIndex)">
            <div class="form-container">
              <mat-form-field appearance="outline">
                <mat-label i18n>Name</mat-label>
                <input matInput id="new-metadata-name" type="text" formControlName="name">
              </mat-form-field>
            </div>
          </td>
          <td [formGroup]="getNewMetadataFormGroup(newItemMetadataIndex)">
            <div class="form-container">
              <mat-form-field appearance="outline">
                <mat-label i18n>Value</mat-label>
                <input matInput id="new-metadata-value" type="text" formControlName="value">
              </mat-form-field>
            </div>
          </td>
          <td>
            <button mat-icon-button
              aria-label="Delete metadata"
              i18n-aria-label
              (click)="onDeleteNewMetadata(newItemMetadataIndex)">
              <mat-icon inline>delete</mat-icon>
            </button>
          </td>
        </tr>
      }
    </table>

    <button mat-stroked-button (click)="onAdd()" i18n>Add metadata</button>
  </fieldset>
</ng-container>
